import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useModules } from "@/lib/useModules";
import { AppTopBar } from "@/components/AppTopBar";

export function importIdentity(iso, name) {
  const d = new Date(iso);
  const date = d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  const time = d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
  return `${date} · ${time}${name ? " — " + name : ""}`;
}

export default function ImportHistory() {
  const { user } = useAuth();
  const { can: canModule, ready: modReady } = useModules();
  const navigate = useNavigate();
  const [imports, setImports] = useState([]);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState([]);
  const exportSelected = async () => {
    if (selected.length === 0) { setError("Pilih minimal satu DA untuk export."); return; }
    try {
      const { data } = await api.get("/orders/imports/export", { params: { batch_ids: selected.join(","), fmt: "xlsx" }, responseType: "blob" });
      const url = URL.createObjectURL(new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
      const a = document.createElement("a"); a.href = url; a.download = "pesanan_da_terpilih.xlsx";
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Export gagal.");
    }
  };

  const toggleSelected = (id) => {
    setSelected((current) => current.includes(id) ? current.filter((x) => x !== id) : [...current, id]);
  };
  const toggleAll = () => {
    setSelected((current) => current.length === imports.length ? [] : imports.map((b) => b.id));
  };

  useEffect(() => {
    api.get("/orders/imports").then(({ data }) => setImports(data))
      .catch((err) => { console.error(err); setError(formatApiErrorDetail(err.response?.data?.detail)); });
  }, []);

  if (modReady && !canModule("ORDER_GINEE")) {
    return (<div className="app-shell"><AppTopBar active="orders" /><main className="content"><div className="alert-error" data-testid="access-denied">Akses ditolak.</div></main></div>);
  }

  return (
    <div className="app-shell">
      <AppTopBar active="orders" />
      <main className="content">
        {error && <div className="alert-error" data-testid="error-banner">{error}</div>}
        <section className="panel" data-testid="import-history-panel">
          <div className="panel-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h2 className="panel-title">Riwayat Import Ginee ({imports.length})</h2>
            <button className="btn-ghost" onClick={exportSelected} disabled={selected.length === 0} data-testid="ginee-import-export">Export Pesanan Terpilih{selected.length ? " (" + selected.length + ")" : ""}</button>
          </div>
          <div className="table-scroll">
            <table className="data-table" data-testid="import-history-table">
              <thead>
                <tr><th><input type="checkbox" checked={imports.length > 0 && selected.length === imports.length} onChange={toggleAll} aria-label="Pilih semua DA" data-testid="import-select-all" /></th><th>Import Batch</th><th>Total Order</th><th>Sudah</th><th>Belum</th><th>Blocked</th><th>Status</th><th>Aksi</th></tr>
              </thead>
              <tbody>
                {imports.length === 0 && <tr><td colSpan={8} className="empty-cell">Belum ada import.</td></tr>}
                {imports.map((b) => (
                  <tr key={b.id} data-testid={`import-row-${b.id}`}>
                    <td><input type="checkbox" checked={selected.includes(b.id)} onChange={() => toggleSelected(b.id)} aria-label={`Pilih DA ${b.id}`} data-testid={`import-select-${b.id}`} /></td>
                    <td>
                      <div style={{ fontWeight: 600 }} data-testid={`import-identity-${b.id}`}>{importIdentity(b.imported_at, b.imported_by_name)}</div>
                      <div className="biz-sub" title={b.original_filename}>{b.original_filename}</div>
                    </td>
                    <td className="mono">{b.total_orders}</td>
                    <td className="mono done" data-testid={`import-processed-${b.id}`}>{b.processed}</td>
                    <td className="mono" data-testid={`import-pending-${b.id}`}>{b.pending}</td>
                    <td className="mono">{b.blocked}</td>
                    <td><span className={`status-pill ${b.status === "CLOSED" ? "off" : "on"}`} data-testid={`import-status-${b.id}`}>{b.status}</span></td>
                    <td><button className="btn-mini" onClick={() => navigate(`/imports/${b.id}`)} data-testid={`import-detail-${b.id}`}>Detail & Picking</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}
